module.exports = __webpack_public_path__ + "static/media/moonsKit.502b94bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsKit.png
// module id = 634
// module chunks = 0